import axios from "./api";

const FaylService = {
    async getFayl(faylName) {
        try {
            const response = await axios.get('/storage/fayl/' + faylName);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting fayl';
        }
    },
    getFaylPath(faylName) {
        try {
            const baseUrl = axios.defaults.baseURL2;
            return baseUrl + 'storage/fayl/' + faylName;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting faylPath';
        }
    },
    getAvatarPath(faylName) {
        try {
            const baseUrl = axios.defaults.baseURL2;
            return baseUrl + 'storage/images/' + faylName;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting image Path';
        }
    },
}

export default FaylService;